import { WebPageType } from '../../constants/webPageType';
import useRedirectHome from '../../hooks/useRedirectHome';

interface NotFoundProps {
  webPageType?: WebPageType;
}

const NotFound: React.FC<NotFoundProps> = ({ webPageType }) => {
  useRedirectHome(true, webPageType);

  return <></>;
};

export default NotFound;
